<template>
  <embed id="swfHolder" :src="mediaPath +'?module=' + $store.state.contentViewer.currentPlayingcontent.passcode"  width="100%" height="100%" flashvars="ver=alcera_1"  type="application/x-shockwave-flash"  />
</template>

<script>
// import axios from 'axios'
export default {
  name: 'swfPlayer',
  loaded: true,
  props: ['path'],
  data () {
    return {
      mediaPath: this.path
    }
  },
  watch: {
    path: function (newValue, oldValue) {
      // console.log('swf:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue
      // var innerHTMLObj = '<object id="swfHolder" width="100%"  height="300px" controls> <param name="FlashVars" value="ver="  /> <param name="movie" value=' + encodeURI(newValue + '?module=' + this.$store.getters.getPasscode) + '"  />            <param name="quality" value="high" />            <param name="bgcolor" value="#ffffff" />            <param name="wmode" value="opaque" /></object>'
      var innerHTMLObj = '<object  width="100%"   controls> <embed class="player" height="400px" src="' + newValue + '?module=' + this.$store.state.contentViewer.currentPlayingcontent.passcode + '" width="100%" controls  flashvars="ver=alcera_1" type="application/x-shockwave-flash"></embed> </object>'
      this.swfHolder = document.getElementById('swfHolder')
      this.swfHolder.innerHTML = ''
      // console.log('here' + this.$store.getters.getPasscode)
      this.swfHolder.innerHTML = innerHTMLObj
    }
  },
  mounted () {
    // console.log('swf player path:' + this.medipaPath)
  },
  beforeDestroy () {
    // console.log('swf player destroy called')
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', {'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0})
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
            .then(response => {
              this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject()
            })
        }) */
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/contentViewer/contentHelper/swfPlayer.vue?34d740e7